module.exports = __webpack_public_path__ + "static/media/diving.2fc31032.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/diving.svg
// module id = 714
// module chunks = 0